import ViewingRoom from "./ViewingRoom";
import WarehouseLocationType from "./WarehouseLocationType";

const WarehouseLocation = ({ viewingRoom = false, type = false } = {}) => `
  id
  description
  capacity
  deleted
  siteId
  typeId
  viewingRoomId
  ${
    viewingRoom
      ? `viewingRoom {
      ${ViewingRoom}
    }`
      : ""
  }
  ${
    type
      ? `type {
      ${WarehouseLocationType}
    }`
      : ""
  }
`;

export default WarehouseLocation;
